import { SvgConsumer } from '@components/icons/svgConsumer';
import { Button } from '@components/ui/button';
import { DatePicker } from '@components/ui/form/date';
import { shortDate, shortDay } from '@utils/i18n';
import { SchedulerDateProps } from './types';
import { addDays, subDays } from 'date-fns';
import { cn } from '@utils/cn';
import { SchedulerCompanyTime } from '../companyTime';

export const SchedulerDate = ({
  date,
  setDate,
  className,
  calendar,
  loading,
}: SchedulerDateProps) => (
  <div className={cn('flex flex-col items-center', className)}>
    <div className="flex items-center gap-1 max-[899px]:w-full max-[899px]:justify-between">
      <div className="flex items-center gap-2 max-[899px]:flex-1 max-[899px]:justify-between">
        <Button
          variant="ghost"
          className="p-1 max-[899px]:h-11 max-[899px]:w-11"
          disabled={loading}
          onClick={() => setDate(subDays(date, 1))}>
          <SvgConsumer id="arrow" className="-scale-x-100" />
        </Button>
        <strong className="flex w-32 select-none items-center justify-center whitespace-nowrap text-heading-xs max-[899px]:w-auto max-[899px]:flex-1">
          {shortDay(date)}, {shortDate(date)}
        </strong>
        <Button
          variant="ghost"
          className="p-1 max-[899px]:h-11 max-[899px]:w-11"
          disabled={loading}
          onClick={() => setDate(addDays(date, 1))}>
          <SvgConsumer id="arrow" />
        </Button>
      </div>
      <DatePicker
        mode="single"
        noText
        noRemove
        className="h-fit w-fit border-0 p-1 text-inherit max-[899px]:h-11 max-[899px]:w-11 max-[899px]:justify-center"
        value={date}
        open={calendar?.open}
        setOpen={calendar?.setOpen}
        modifiers={calendar?.modifiers}
        modifiersClassNames={calendar?.modifiersClassNames}
        legend={calendar?.legend}
        todayDisabled={loading}
        onChange={(value) => {
          if (!value) return;
          setDate(value);
        }}
      />
    </div>
    <SchedulerCompanyTime />
  </div>
);
